import sample from "lodash/sample";
import classNames from "classnames";
import React, { useEffect, useState } from "react";
import champions from "./TFT-sets/2020-04-16-set3/champions.json";
import traits from "./TFT-sets/2020-04-16-set3/traits.json";

const originTraits = traits.filter((t) => t.type === "origin");
const classTraits = traits.filter((t) => t.type === "class");

function AnswerItem({ root, title }) {
  return (
    <div>
      <div className="answer-header">{title}</div>
      <div className="answer-answer">{root ? root.name : "_____________"}</div>
    </div>
  );
}

function OptionButton({ item, selected, toggle, icon }) {
  return (
    <button
      className={
        selected &&
        ((selected.key && selected.key === item.key) ||
          (selected.name && selected.name === item.name))
          ? "active trait-toggle"
          : "trait-toggle"
      }
      key={item.key || item.name}
      onClick={() => toggle(item)}
      style={{
        fontSize: "1em",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {icon}
      {item.name}
    </button>
  );
}

function OptionStack({ selected, setSelected, options, icon }) {
  return (
    <div
      className="trait-stack"
      style={{
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        justifyContent: "center",
      }}
    >
      {options.map((t) => {
        return (
          <OptionButton
            item={t}
            key={t.key || t.name}
            selected={selected}
            toggle={setSelected}
            icon={icon(t)}
          />
        );
      })}
    </div>
  );
}

function ChampQuiz({}) {
  const [selectedOrigin, setSelectedOrigin] = useState(null);
  const [selectedClass, setSelectedClass] = useState(null);
  const [selectedSecondClass, setSelectedSecondClass] = useState(null);
  const [currentChamp, setCurrentChamp] = useState(null);
  useEffect(() => setCurrentChamp(sample(champions)), []);
  // useEffect(
  //   () => setCurrentChamp(champions.find((c) => c.name === "Irelia")),
  //   []
  // );

  if (!currentChamp) {
    return "";
  }

  const threeTraitChamp = currentChamp.traits.length === 3;

  let isCompleted = false;
  if (selectedOrigin && selectedClass) {
    isCompleted =
      currentChamp.traits[0] === selectedOrigin.name &&
      currentChamp.traits[1] === selectedClass.name;
  }

  if (threeTraitChamp) {
    isCompleted = false;

    if (selectedOrigin && selectedClass && selectedSecondClass) {
      isCompleted =
        currentChamp.traits[0] === selectedOrigin.name &&
        selectedClass.name !== selectedSecondClass.name &&
        (currentChamp.traits[1] === selectedClass.name ||
          currentChamp.traits[2] === selectedClass.name) &&
        (currentChamp.traits[1] === selectedSecondClass.name ||
          currentChamp.traits[2] === selectedSecondClass.name);
    }
  }

  let isFailed = false;
  if (selectedOrigin && selectedClass) {
    isFailed =
      currentChamp.traits[0] !== selectedOrigin.name ||
      currentChamp.traits[1] !== selectedClass.name;
  }

  if (threeTraitChamp) {
    isFailed = false;

    if (selectedOrigin && selectedClass && selectedSecondClass) {
      isFailed =
        currentChamp.traits[0] !== selectedOrigin.name ||
        selectedClass.name === selectedSecondClass.name ||
        (currentChamp.traits[1] !== selectedClass.name &&
          currentChamp.traits[2] !== selectedClass.name) ||
        (currentChamp.traits[1] !== selectedSecondClass.name &&
          currentChamp.traits[2] !== selectedSecondClass.name);
    }
  }

  const image = require(`./TFT-sets/2020-04-16-set3/champions/${currentChamp.name
    .toLocaleLowerCase()
    .replace(/[^A-Z0-9]/gi, "")}.png`);

  return (
    <div
      style={{
        flex: 1,
        overflow: "auto",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div>
        <div
          className={classNames("champ-header", {
            success: isCompleted,
            failed: isFailed,
          })}
          style={{ display: "flex", alignItems: "center" }}
        >
          <div style={{ flex: 1 }}>
            <h2>{currentChamp.name}</h2>
          </div>
          <div>
            <img src={image} className="App-logo" alt="logo" />
          </div>
          <div className="answer-section" style={{ flex: 1 }}>
            <AnswerItem title="Origin" root={selectedOrigin} />
            <AnswerItem title="Class" root={selectedClass} />
            {threeTraitChamp && (
              <AnswerItem title="Class" root={selectedSecondClass} />
            )}
          </div>
        </div>
      </div>
      <div style={{ margin: "10px 0" }}>
        {!isCompleted && (
          <button
            onClick={() => {
              setSelectedOrigin(
                originTraits.find((t) => t.name === currentChamp.traits[0])
              );
              setSelectedClass(
                classTraits.find((t) => t.name === currentChamp.traits[1])
              );

              if (threeTraitChamp) {
                setSelectedSecondClass(
                  classTraits.find((t) => t.name === currentChamp.traits[2])
                );
              }
            }}
            style={{ fontSize: "1em", padding: "2px 5px" }}
          >
            Reveal{" "}
            <span role="img" aria-label="crying-emoji">
              😭
            </span>
          </button>
        )}
        {isCompleted && (
          <button
            onClick={() => window.location.reload(false)}
            style={{ fontSize: "1em", padding: "2px 5px" }}
          >
            Try another!{" "}
            <span role="img" aria-label="crying-emoji">
              🙉
            </span>
          </button>
        )}
      </div>
      <div className="trait-stack-wrapper">
        <div className="trait-section-header">Origin</div>
        <OptionStack
          selected={selectedOrigin}
          options={originTraits}
          setSelected={setSelectedOrigin}
          icon={(item) => {
            const image = require(`./TFT-sets/2020-04-16-set3/traits/${item.name
              .toLocaleLowerCase()
              .replace(/[^A-Z0-9]/gi, "")}.png`);

            return (
              <img
                src={image}
                className="trait-icon"
                alt="Trait Icon"
                style={{ marginRight: "5px" }}
              />
            );
          }}
        />
        <div className="trait-section-header">Class</div>
        <OptionStack
          selected={selectedClass}
          options={classTraits}
          setSelected={setSelectedClass}
          icon={(item) => {
            const image = require(`./TFT-sets/2020-04-16-set3/traits/${item.name
              .toLocaleLowerCase()
              .replace(/[^A-Z0-9]/gi, "")}.png`);

            return (
              <img
                src={image}
                className="trait-icon"
                alt="Trait Icon"
                style={{ marginRight: "5px" }}
              />
            );
          }}
        />
        {currentChamp.traits.length === 3 && [
          <div className="trait-section-header">Second Class</div>,
          <OptionStack
            selected={selectedSecondClass}
            options={classTraits}
            setSelected={setSelectedSecondClass}
            icon={(item) => {
              const image = require(`./TFT-sets/2020-04-16-set3/traits/${item.name
                .toLocaleLowerCase()
                .replace(/[^A-Z0-9]/gi, "")}.png`);

              return (
                <img
                  src={image}
                  className="trait-icon"
                  alt="Trait Icon"
                  style={{ marginRight: "5px" }}
                />
              );
            }}
          />,
        ]}
      </div>
    </div>
  );
}

export default ChampQuiz;
export { AnswerItem, OptionStack };
